<template>
	<div>
		<v-text-field
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			type="number"
			:name="param.name"
			clearable
			@input="emitUpdate($event)"
			:readonly="readonly">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-text-field>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false
		}
	},
	methods: {
		emitUpdate (val) {
			let int = parseInt(val)
			if (Number.isNaN(int)) int = ''
			this.$emit('update:value', int)
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		integerCheck (value) {
			if (!value) return true
			return Number.isInteger(value) || 'Nombre entier uniquement'
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		this.rules.push(this.integerCheck)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/integer.vue